export	const BOOKS_HELP_DATA = [
    {
        id: "ficha",
        textButton: {
            default: "Ficha expandida de los libros",
            translationPath: "books.ficha.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1001684077?h=8bbde0cec2&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
            translationPath: "books.ficha.url",
        },
    },
    {
        id: "epub",
        textButton: {
            default: "Tipos de libros: ePub",
            translationPath: "books.libros_epub.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1015730260?h=af6e1959ae",
            translationPath: "books.libros_epub.url",
        },
    },
    {
        id: "graficos",
        textButton: {
            default: "Tipos de libros: Gráficos",
            translationPath: "books.libros_graficos.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1015730326?h=d1a4717f37",
            translationPath: "books.libros_graficos.url",
        },
    },
    {
        id: "interactivos",
        textButton: {
            default: "Tipos de libros: Interactivos",
            translationPath: "books.libros_interactivos.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1015730303?h=d53b379964",
            translationPath: "books.libros_interactivos.url",
        },
    },
    {
        id: "comic",
        textButton: {
            default:"Tipos de libros: Cómic",
            translationPath: "books.libros_comic.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1015730226?h=eb72ef62d3",
            translationPath: "books.libros_comic.url",
        },
    }
]